import "./style.css";

export function DatasViewItems() {
  return (
    <div className="">
      <ul className="data_items_list">
        <li>
          <div className="bodr">
            <div className="pic">
              <img
                src="./img/dataradarsat.png"
                className="js_thumb"
                title=""
                alt=""
              />
            </div>
            <a href="/datas?sel=RADARSAT" className="txts">
              <p className="sy">数据产品</p>
              <p className="nowti">RADARSAT-2</p>
              <p className="tx">
                RADARSAT-2是C波段高分辨率商用雷达卫星，分辨率为1-100m，拥有全极化模式和新增宽模式，具有近实时编程、近实时交付的能力。
              </p>
              <p className="date"> 2017-09-26 </p>
            </a>
            <a href="/datas?sel=RADARSAT" className="ixmore">
              <i className="ico"></i>
            </a>
          </div>
        </li>
        <li>
          <div className="bodr">
            <div className="pic">
              <img
                src="./img/dataais.png"
                className="js_thumb"
                title=""
                alt=""
              />
            </div>
            <a href="/datas?sel=AIS" className="txts">
              <p className="sy">数据产品</p>
              <p className="nowti">AIS船舶监测</p>
              <p className="tx">
                exactEarth公司作为专业的卫星AIS数据供应商，是全球唯一一家可以做到实时监控全球范围内所有装备AIS船舶的天基AIS数据供应商，其卫星AIS数据产品在业内处于领先地位。
              </p>
              <p className="date"> 2020-07-17 </p>
            </a>
            <a href="/datas?sel=AIS" className="ixmore">
              <i className="ico"></i>
            </a>
          </div>
        </li>
      </ul>
    </div>
  );
}
